import './image_overlay.scss'

// Function to show custom image overlay that can be used for both autoplay and non-autoplay scenarios
export const showImageOverlay = function (player, elem, options = {}) {
  const container = elem.closest('.video-js')
  const imageOverlayUrl = elem.data('image-overlay-url')

  if (!imageOverlayUrl) return false

  // Once overlay is dismissed, do not show it again
  if (elem.data('image-overlay-dismissed')) return false

  // Get dynamic styling values
  const imageOverlayWidth = elem.data('image-overlay-width') || '60%'

  container.addClass('vjs-image-overlay-active')
  container.append(`
    <div class="video-js__image-overlay">
      <img src="${imageOverlayUrl}" alt="Click to play" style="max-width: ${imageOverlayWidth};" />
    </div>
  `)

  const clickHandler = (e) => {
    if (!e.target.closest('.vjs-progress-control, .vjs-play-control')) {
      // If clicked anywhere other than the progress bar/play button, make sure we go back to 0:00
      if (options.resetTime !== false) {
        player.currentTime(0)
      }
    }
    if (!e.target.closest('.vjs-volume-panel')) {
      // If clicked anywhere other than the volume panel, restore volume if provided
      if (options.originalVolume !== undefined) {
        player.volume(options.originalVolume)
      }
    }
    if (!e.target.closest('.vjs-play-control')) {
      // If clicked anywhere other than the play button, start playback
      setTimeout(() => player.play(), 0) // defer to make sure videojs doesn't pause right after we play
    }

    dismissOverlay(elem)

    container.find('.video-js__image-overlay').remove()
    container.removeClass('vjs-image-overlay-active')
  }

  container[0].addEventListener('click', clickHandler, { once: true, capture: true })

  return true
}

// Setup event handlers for image overlay functionality
export function setupImageOverlay(player, $element) {
  const imageOverlayUrl = $element.data('image-overlay-url')

  if (!imageOverlayUrl) return

  // Show overlay initially if video is paused
  if (player.paused()) showImageOverlay(player, $element, { resetTime: false })

  if (!$element.data('autoplay')) {
    player.on('play', function () {
      // Hide overlay
      const container = $element.closest('.video-js')
      container.find('.video-js__image-overlay').remove()
      container.removeClass('vjs-image-overlay-active')
    })
  }
}

// Utility functions for overlay state management
export function dismissOverlay(elem) {
  elem.data('image-overlay-dismissed', true)
}
